<template>
  <el-dialog v-loading="loading" class="drawer--fixed-header" :visible="visible" width="30%"
    :title="`${action === 'new' ? '新建' : '编辑'}用户`" :close-on-click-modal="false" @close="close">
    <el-form ref="form" :model="form" label-width="100px" :rules="rules" label-suffix="：">
      <el-form-item label="用户姓名" prop="nickName">
        <el-input v-model="form.nickName" maxlength="20" placeholder="请输入用户姓名" />
      </el-form-item>
      <el-form-item label="手机号码" prop="phonenumber">
        <el-input v-model="form.phonenumber" maxlength="20" placeholder="请输入手机号码" />
      </el-form-item>
      <el-form-item v-if="action !== 'edit'" label="密码" prop="password">
        <el-input v-model="form.password" type="password" maxlength="20" placeholder="请输入新密码" />
      </el-form-item>
      <el-form-item label="角色" prop="roleIds">
        <el-select v-model="form.roleIds" collapse-tags multiple placeholder="请选择">
          <el-option v-for="item in options" :key="item.roleId" :label="item.roleName" :value="item.roleId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" class="common-btn" @click="submit">确定</el-button>
      <el-button type="default" @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { listRole } from '@/api/system/role.js'
import { addUser, updateUser } from '@/api/system/user.js'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: 'new'
    },
    data: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/ // matches 11-digit mobile numbers starting with 1
      if (value && !passwordPattern.test(value)) {
        callback(new Error('请输入6位数以上大小写字母+数字的密码'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      form: {
        nickName: '',
        phonenumber: '',
        roleIds: []
      },
      rules: {
        nickName: [{ required: true, message: '请填写昵称', trigger: 'blur' }],
        phonenumber: [
          { required: true, message: '请填写手机号码', trigger: 'blur' },
          { pattern: /^1(\d{10})$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { required: true, validator: validatePassword, trigger: ['blur', 'change'] }
        ],
        roleIds: [{ required: true, message: '请选择角色', trigger: 'change' }]
      },

      defaultProps: {
        children: 'children',
        label: 'label'
      },
      options: []
    }
  },

  watch: {
    data(newVal) {
      console.log(newVal);
      if (this.action === 'edit') {
        this.form = JSON.parse(JSON.stringify(newVal))
        console.log(this.form);
        if (newVal.roleIds) {
          this.$set(this.form, 'roleIds', newVal.roleIds.split(','))
        } else {
          this.$set(this.form, 'roleIds', [])
        }
      }
    }
  },

  created() {
    this.getRoles()
  },

  methods: {
    // 提交保存
    submit() {
      const form = JSON.parse(JSON.stringify(this.form))
      this.$refs.form.validate().then(async (valid) => {
        if (!valid) return false
        this.loading = true
        this.form.appId = '4'
        let res = null
        try {
          if (this.action === 'new') res = await addUser(this.form)
          else res = await updateUser(this.form)
          this.loading = false
        } catch (error) {
          this.loading = false
        }
        const { code, msg } = res
        if (code === 200) {
          if (this.action === 'new') this.$emit('created', form)
          this.dialogVisible = true
          this.close()
          this.$parent.getList()
        } else {
          this.$message.error(msg)
        }
      })
    },

    close() {
      this.$refs.form.resetFields()
      this.form.nickName = ''
      this.form.phonenumber = ''
      this.form.roleIds = []
      this.$emit('close')
    },

    // 获取角色列表
    async getRoles() {
      const { rows } = await listRole({ status: 0, appId: '4' })
      this.options = rows
    }
  }
}
</script>
